<template>
  <div class="about-footer">
    <div class="cover">
      <img src="https://res.jaadee.net/uploads/upgrade/articleVideo/20210323/zcgojxazqa.jpeg" alt="">
    </div>
   <!-- <p class="online">此时共有194000位翠友在线</p>-->
    <p class="description">
        翡翠王朝成立于2008年3月21日 <br>
        我们以超值好珠宝和舒心服务造福顾客
    </p>
    <p class="company">
      云南翡翠王朝网络科技有限公司
    </p>
  </div>
</template>

<script>

    export default {
        name: 'about-footer',
        components: {

        },
        data() {
            return {

            }
        },
        computed: {
        },
        mounted() {
        },
        methods:{

        }
    }
</script>

<style lang="scss" scoped >
.about-footer{
  padding: 0 0.21rem 1.03rem 0.21rem;
  background-color: rgba(255,255,255,1);
  .description{
    padding-top: 0.4rem;
    font-size:0.1467rem;
    color:rgba(78,78,78,1);
    line-height:0.2rem;
  }
  .company{
    padding-top: 0.11rem;
    font-size:0.1733rem;
    color:rgba(114,114,114,1);
    line-height:0.2467rem;
  }
}
</style>
